import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { FreightRequest } from "../interfaces/request/freight-request.interface";
import { FreightResponse } from "../interfaces/response/freight-response.interface";
import { FreightMapper } from "../mapper/freight.mapper";
import { Freight } from "../interfaces/model/freight.interface";

@Injectable({
  providedIn: "root"})
export class FreightService {
  constructor(private _httpClient: HttpClient) {}

  calculateFreight(request: FreightRequest): Observable<Freight[]> {
    return this._httpClient
      .post<
        FreightResponse[]
      >(`${environment.backend}/shipping/calculate`, request)
      .pipe(map((response) => FreightMapper.mapToFreight(response)));
  }
}
